import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidFocusReading } from '../../../../mechanics/rid-focus-reading/rid-focus-reading';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-focus-reading-page',
  imports: [RidFocusReading],
  templateUrl: './focus-reading-page.html',
})
export class FocusReadingPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly pace = computed(() => parseInt(this.queryParams()['pace'] ?? '200'));
}
